import React from 'react';
import { useTranslation } from 'react-i18next';
import { Lock, Mail } from 'lucide-react';

function InvestorReports() {
  const { t } = useTranslation();

  const handleContactSales = () => {
    // W prawdziwej aplikacji tutaj byłoby otwarcie modala lub przekierowanie
    window.location.href = 'mailto:sales@caelus.com';
  };

  return (
    <div className="space-y-4">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">{t('investorReports.title')}</h1>
        <p className="text-gray-600 text-sm leading-relaxed max-w-2xl">
          {t('investorReports.subtitle')}
        </p>
      </div>

      {/* Locked Feature Card */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12">
        <div className="max-w-2xl mx-auto text-center">
          {/* Lock Icon */}
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gray-100 rounded-full mb-6">
            <Lock className="w-10 h-10 text-gray-400" />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            {t('investorReports.lockedModule.title')}
          </h2>

          {/* Description */}
          <p className="text-gray-600 text-base leading-relaxed mb-8">
            {t('investorReports.lockedModule.description')}
          </p>

          {/* Contact Sales Button */}
          <button
            onClick={handleContactSales}
            className="inline-flex items-center space-x-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors duration-200"
          >
            <Mail className="w-5 h-5" />
            <span>{t('investorReports.lockedModule.contactSales')}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default InvestorReports;

